// 百科：英文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 个人百科
export const personal = Object.freeze({
  "myWiki.center": "Wiki Center",
  "myWiki.all": "All",
  "myWiki.viewLibrary": "Browse the Wiki",
  "myWiki.publish": "Publish an Entry",
  "myWiki.mine.title": "My Publications",
  "myWiki.mine.description":
    "View entries published or maintained by this account.",
  "myWiki.mine.search": "Search my publications",
  "myWiki.mine.entry": "Entry",
  "myWiki.mine.definition": "Definition",
  "myWiki.mine.source": "Source",
  "myWiki.mine.status": "Status",
  "myWiki.mine.reviewFeedback": "Review Feedback",
  "myWiki.mine.publishedAt": "Published At",
  "myWiki.mine.actions": "Actions",
  "myWiki.mine.view": "View",
  "myWiki.mine.noDefinition": "No definition available",
  "myWiki.mine.empty": "No publications for this account",
  "myWiki.mine.contributed": "Contributed",
  "myWiki.mine.userSource": "User Submission",
  "myWiki.mine.internalSource": "Internal Submission",
  "myWiki.status.reviewing": "Pending Review",
  "myWiki.status.pending_review": "AI Review",
  "myWiki.status.ai_correction_pending": "Pending Confirmation",
  "myWiki.status.revision_required": "Changes Required",
  "myWiki.status.manual_review": "Manual Review",
  "myWiki.status.published": "Published",
  "myWiki.status.offline": "Unpublished",
  "myWiki.status.scheduled": "Scheduled",
  "myWiki.status.rejected": "Rejected",
  "myWiki.status.draft": "Draft",
  "myWiki.collection.title": "My Favorites",
  "myWiki.collection.summary": "Favorites summary",
  "myWiki.collection.saved": "Saved",
  "myWiki.collection.current": "Shown",
  "myWiki.collection.brands": "Brands",
  "myWiki.collection.description":
    "Manage saved chip entries and quickly review their details and completeness.",
  "myWiki.collection.searchPlaceholder": "Search model, brand, or category",
  "myWiki.collection.noSummary": "No summary available",
  "myWiki.collection.completeness": "Data completeness",
  "myWiki.collection.viewDetail": "View Details",
  "myWiki.collection.removeFavorite": "Remove from Favorites",
  "myWiki.collection.empty": "No saved entries",
  "myWiki.collection.removed": "Removed from favorites",
  "myWiki.collection.removeFailed":
    "Could not remove this favorite. Please try again.",
  "myWiki.questions.title": "My Q&A",
  "myWiki.questions.description":
    "Review your questions, answers, and comments in the Chip Wiki.",
  "myWiki.questions.enterCommunity": "Open Wiki Q&A",
  "myWiki.questions.questions": "My Questions",
  "myWiki.questions.answers": "My Answers",
  "myWiki.questions.comments": "My Comments",
  "myWiki.questions.loginPrompt": "Sign in to view your Q&A activity.",
  "myWiki.questions.loginNow": "Sign In",
  "myWiki.questions.loading": "Loading…",
  "myWiki.questions.retry": "Retry",
  "myWiki.questions.loginAgain": "Sign In Again",
  "myWiki.questions.attachmentAnswer": "Answer with attachments",
  "myWiki.questions.noDescription": "No further details",
  "myWiki.questions.answerCount": "{count} answers",
  "myWiki.questions.answered": "Answered this question",
  "myWiki.questions.commented": "Commented on this question",
  "myWiki.questions.delete": "Delete",
  "myWiki.questions.deleted": "Deleted",
  "myWiki.questions.viewDiscussion": "View Discussion",
  "myWiki.questions.empty.questions": "No questions yet",
  "myWiki.questions.empty.answers": "No answers yet",
  "myWiki.questions.empty.comments": "No comments yet",
  "myWiki.questions.loginExpired":
    "Your session has expired. Please sign in again.",
  "myWiki.questions.loadFailed":
    "Could not load Q&A activity. Please try again.",
  "myWiki.questions.deleteSuccess": "Deleted",
  "myWiki.questions.deleteOwnOnly": "You can only delete your own content.",
  "myWiki.questions.deleteUnavailable":
    "This content or its delete action is unavailable. Nothing was deleted.",
  "myWiki.questions.deleteFailed":
    "Could not delete this item. Please try again.",
});

// 百科受控显示
export const display = Object.freeze({
  "wikiDisplay.category.memory": "Memory",
  "wikiDisplay.category.flash": "Flash memory",
  "wikiDisplay.category.nand": "NAND Flash",
  "wikiDisplay.category.nor": "NOR Flash",
  "wikiDisplay.category.ssd": "Solid-state drive",
  "wikiDisplay.category.chip": "Chip",
  "wikiDisplay.category.wiki": "Encyclopedia",
  "wikiDisplay.category.mcu": "Microcontrollers",
  "wikiDisplay.category.power": "Power management ICs",
  "wikiDisplay.category.interface": "Interface ICs",
  "wikiDisplay.category.sensor": "Sensors",
  "wikiDisplay.parameter.capacity": "Capacity",
  "wikiDisplay.parameter.density": "Density",
  "wikiDisplay.parameter.accessTime": "Access time",
  "wikiDisplay.parameter.package": "Package",
  "wikiDisplay.parameter.voltage": "Voltage",
  "wikiDisplay.parameter.operatingVoltage": "Operating voltage",
  "wikiDisplay.parameter.supplyVoltage": "Supply voltage",
  "wikiDisplay.parameter.speed": "Speed",
  "wikiDisplay.parameter.frequency": "Frequency",
  "wikiDisplay.parameter.temperature": "Operating temperature",
  "wikiDisplay.parameter.interface": "Interface",
  "wikiDisplay.parameter.width": "Bus width",
  "wikiDisplay.parameter.organization": "Organization",
  "wikiDisplay.parameter.pins": "Pin count",
  "wikiDisplay.parameter.process": "Process",
  "wikiDisplay.parameter.power": "Power consumption",
  "wikiDisplay.parameter.brand": "Brand / manufacturer",
  "wikiDisplay.parameter.manufacturer": "Manufacturer",
  "wikiDisplay.parameter.category": "Category",
  "wikiDisplay.parameter.model": "Model",
  "wikiDisplay.parameter.period": "Supply status",
  "wikiDisplay.parameter.description": "Description",
  "wikiDisplay.parameter.base": "Basic information",
  "wikiDisplay.parameter.spec": "Core specifications",
  "wikiDisplay.parameter.packaging": "Package information",
  "wikiDisplay.parameter.parameter": "Parameter",
  "wikiDisplay.parameter.datasheet": "Datasheet",
  "wikiDisplay.parameter.body": "Encyclopedia content",
  "wikiDisplay.parameter.dataRate": "Data rate",
  "wikiDisplay.parameter.productName": "Product name",
  "wikiDisplay.parameter.partNumber": "Part number",
  "wikiDisplay.parameter.series": "Product series",
  "wikiDisplay.parameter.price": "Reference unit price",
  "wikiDisplay.parameter.quantity": "Stock quantity",
  "wikiDisplay.parameter.location": "Stock location",
  "wikiDisplay.parameter.batch": "Batch",
  "wikiDisplay.parameter.condition": "Condition",
  "wikiDisplay.parameter.application": "Applications",
  "wikiDisplay.parameter.moq": "Minimum order quantity",
  "wikiDisplay.parameter.leadTime": "Delivery lead time",
  "wikiDisplay.parameter.validity": "Validity",
  "wikiDisplay.parameter.alternative": "Alternative model",
  "wikiDisplay.parameter.cas": "CAS latency",
  "wikiDisplay.status.draft": "Draft",
  "wikiDisplay.status.reviewing": "Pending review",
  "wikiDisplay.status.processing": "Under review",
  "wikiDisplay.status.manual": "Manual review",
  "wikiDisplay.status.confirm": "Awaiting confirmation",
  "wikiDisplay.status.revision": "Revision required",
  "wikiDisplay.status.rejected": "Review failed",
  "wikiDisplay.status.denied": "Rejected",
  "wikiDisplay.status.published": "Published",
  "wikiDisplay.status.offline": "Offline",
  "wikiDisplay.status.scheduled": "Scheduled",
  "wikiDisplay.review.pendingPreview": "Pending version preview",
  "wikiDisplay.review.view": "Encyclopedia details",
  "wikiDisplay.review.pendingVersionHint":
    "This is the user's submitted revision, not the published version.",
  "wikiDisplay.review.readOnlyHint":
    "This read-only view shows the entry's public content and publication status.",
  "wikiDisplay.review.internal": "Internal encyclopedia management",
  "wikiDisplay.review.processingTitle": "This content is under review",
  "wikiDisplay.review.processingHint":
    "This submission preview is not public. Other users can see the published version after approval.",
  "wikiDisplay.review.aiTitle": "AI corrections are available",
  "wikiDisplay.review.aiHint":
    "Compare the original and proposed changes. Acceptance triggers another review; otherwise manual review is required.",
  "wikiDisplay.review.manualTitle": "This content is under manual review",
  "wikiDisplay.review.manualHint":
    "Approved content will be published; otherwise it will be returned for revision.",
  "wikiDisplay.review.revisionTitle": "This content was returned for revision",
  "wikiDisplay.review.revisionHint":
    "Revise according to the review feedback and resubmit.",
  "wikiDisplay.review.rejectedTitle": "This content did not pass review",
  "wikiDisplay.review.rejectedHint":
    "Publication of this version has stopped. See the review feedback below.",
  "wikiDisplay.review.offlineTitle":
    "An administrator took this content offline",
  "wikiDisplay.review.offlineHint":
    "This content is no longer public. See the management feedback below.",
  "wikiDisplay.review.draftTitle": "This entry has an unsubmitted revision",
  "wikiDisplay.review.draftHint":
    "Only you can see this draft; the published version remains public.",
  "wikiDisplay.review.withdrawnTitle": "This submission was withdrawn",
  "wikiDisplay.review.withdrawnHint":
    "Only you can see this content; it is no longer in the review queue.",
  "wikiDisplay.review.publishedTitle": "This content is published",
  "wikiDisplay.review.publishedHint":
    "This approved entry is public and accessible from the encyclopedia and related products.",
  "wikiDisplay.review.waitManual": "Awaiting manual review",
  "wikiDisplay.review.waitInternal":
    "Awaiting internal approval for publication",
  "wikiDisplay.review.allowed": "Approved for the public encyclopedia",
  "wikiDisplay.review.hidden": "No longer publicly visible",
  "wikiDisplay.review.stopped": "Publication of this version has stopped",
  "wikiDisplay.review.internalDraft": "Internal draft, not public",
  "wikiDisplay.review.checkSubmitted":
    "Review this submitted version and approve it or return it for revision.",
  "wikiDisplay.review.checkQueue":
    "Check the images, parameters, fields and description before approving publication.",
  "wikiDisplay.review.checkPublished":
    "This approved entry is public. You may check completeness and add specifications, images or product links.",
  "wikiDisplay.review.checkOffline":
    "This entry is offline. Restore it through manual review rather than the user revision queue.",
  "wikiDisplay.review.checkRejected":
    "This version failed manual review and cannot proceed to publication.",
  "wikiDisplay.review.checkDraft":
    "This is an internal draft. Complete it before submitting for review or publishing.",
  "wikiDisplay.review.approve": "Approve and publish",
  "wikiDisplay.review.return": "Return for revision",
  "wikiDisplay.review.returnMore": "Return for more information",
  "wikiDisplay.review.offlinePending": "Take offline for review",
  "wikiDisplay.review.pendingAgain": "Return to pending review",
  "wikiDisplay.review.saveDraft": "Save draft",
  "wikiDisplay.review.plan": "Plan review",
  "wikiDisplay.review.identify": "Identify product model",
  "wikiDisplay.review.retrieve": "Retrieve datasheet evidence",
  "wikiDisplay.review.extract": "Extract key parameters",
  "wikiDisplay.review.advertising": "Check advertising and redirects",
  "wikiDisplay.review.objectivity": "Check content objectivity",
  "wikiDisplay.review.verify": "Verify individual claims",
  "wikiDisplay.review.check": "Review check",
  "wikiDisplay.review.supported": "Supported by the source",
  "wikiDisplay.review.contradicted": "Contradicted by the source",
  "wikiDisplay.review.insufficient": "Insufficient evidence",
  "wikiDisplay.review.unverified": "Awaiting verification",
  "wikiDisplay.parameterText": "{label}: {value}",
  "wikiDisplay.favorite.added": "Added to favorites",
  "wikiDisplay.favorite.removed": "Removed from favorites",
  "wikiDisplay.error.AUTH_REQUIRED": "Sign in to continue",
  "wikiDisplay.error.FORBIDDEN": "Your account cannot perform this action",
  "wikiDisplay.error.NOT_FOUND": "Encyclopedia content not found",
  "wikiDisplay.error.INVALID_ARGUMENT":
    "Check the submitted content and parameters",
  "wikiDisplay.error.RATE_LIMITED": "Too many requests. Try again later.",
  "wikiDisplay.error.TIMEOUT":
    "The encyclopedia request timed out. Try again later.",
  "wikiDisplay.error.UNAVAILABLE":
    "The encyclopedia service is temporarily unavailable",
  "wikiDisplay.error.REQUEST_FAILED": "The operation failed. Try again later.",
  "wikiDisplay.error.PUBLISH_FAILED":
    "Could not submit encyclopedia content. Try again later.",
  "wikiDisplay.error.ROW_REQUIRED": "Row {index} is missing required content",
});

// 百科页面
export const pages = Object.freeze({
  "wiki.backToEntry": "Back to entry",
  "wiki.community": "Chip Encyclopedia Community",
  "wiki.questions": "Q&A",
  "wiki.questionsIntro":
    "Discuss part specifications, usage experience, selection, and alternatives to help others find answers.",
  "wiki.ask": "Ask a question",
  "wiki.searchQuestions": "Search questions",
  "wiki.loadingQuestions": "Loading Q&A…",
  "wiki.retry": "Retry",
  "wiki.awaitingAnswer": "Awaiting answer",
  "wiki.questionMark": "Q",
  "wiki.answerMark": "A",
  "wiki.answerImage": "Answer attachment",
  "wiki.answerCount": "{count} answers",
  "wiki.answerQuestion": "Answer question",
  "wiki.writeAnswer": "Write your answer…",
  "wiki.pendingImage": "Image to publish",
  "wiki.deleteImage": "Remove image",
  "wiki.deleteFile": "Remove file",
  "wiki.attachmentHelp":
    "PNG/JPG/GIF/WebP images and PDF/TXT/CSV/DOCX/XLSX/PPTX files; up to 8 files in total, 10 MB each",
  "wiki.addImage": "Add image",
  "wiki.addFile": "Add file",
  "wiki.cancel": "Cancel",
  "wiki.publishAnswer": "Post answer",
  "wiki.noQuestions": "No related questions found",
  "wiki.firstQuestion": "Post the first question",
  "wiki.continueBrowsing": "Continue browsing",
  "wiki.similarQuestions": "Similar questions",
  "wiki.similarHint": "These questions may help you find an answer faster",
  "wiki.discussionCount": "{count} discussions",
  "wiki.hotQuestions": "Popular Q&A",
  "wiki.noHotQuestions": "No popular discussions yet",
  "wiki.answerInvitations": "Questions awaiting you",
  "wiki.relatedProducts": "Questions about related products across XSOU",
  "wiki.publishQuestion": "Post question",
  "wiki.askHint": "A clear question is more likely to receive a useful answer",
  "wiki.discussing": "Discussing",
  "wiki.questionRules": "Q&A posting rules",
  "wiki.ruleRelevant":
    "Ask about product specifications, experience, selection, or alternatives",
  "wiki.ruleNoTrade":
    "Do not post transaction offers, contact details, or unrelated information",
  "wiki.questionTitle": "Question title",
  "wiki.titleHint": "Describe what you want to know in one sentence",
  "wiki.titleExample":
    "For example: Can this part replace another model in the same series?",
  "wiki.details": "Additional details",
  "wiki.detailsHint":
    "Add your use case, confirmed specifications, or observed behavior",
  "wiki.detailsPlaceholder": "More context helps others answer accurately…",
  "wiki.productFallback": "This product",
  "wiki.allQuestions": "All Q&A",
  "wiki.communityQuestions": "Community Q&A",
  "wiki.wikiUser": "Encyclopedia user",
  "wiki.communityUser": "Community user",
  "wiki.loginFirst": "Please sign in first",
  "wiki.operationFailed":
    "Operation failed. Please try again later; your draft has been kept.",
  "wiki.loadFailed":
    "Could not load Q&A. Check the product link and try again.",
  "wiki.fileInvalid": "{name} has an unsupported format or size",
  "wiki.fileLimit": "Up to 8 images and files in total",
  "wiki.enterFromProduct":
    "Open Q&A from a product encyclopedia entry to ask a question",
  "wiki.questionPublished": "Question posted",
  "wiki.answerPublished": "Answer posted",
  "wiki.heroTitle": "Chip Encyclopedia: knowledge at your fingertips",
  "wiki.searchPlaceholder": "Search models, brands, or categories",
  "wiki.categoryLabel": "Chip category:",
  "wiki.productCount": "{count} products",
  "wiki.collapse": "Collapse",
  "wiki.expand": "Expand",
  "wiki.brandLabel": "Brand:",
  "wiki.brandInitials": "Filter brands by initial",
  "wiki.brandFilter": "Filter brands",
  "wiki.all": "All",
  "wiki.publishEntry": "Publish entry",
  "wiki.noDescription": "No description",
  "wiki.unfavorite": "Remove from favorites",
  "wiki.favorite": "Add to favorites",
  "wiki.loadingMore": "Loading…",
  "wiki.loadMoreProducts": "Load more products",
  "wiki.noProducts": "No related product information",
  "wiki.publishEntryTitle": "Publish an encyclopedia entry",
  "wiki.publishEntryHint":
    "Submitted entries enter review and appear publicly after approval.",
  "wiki.entryName": "Entry name",
  "wiki.entryNamePlaceholder": "Enter an encyclopedia entry name",
  "wiki.entryDefinition": "Entry definition",
  "wiki.entryDefinitionPlaceholder":
    "Explain what it is, where it is used, and its key characteristics",
  "wiki.entryBody": "Encyclopedia content",
  "wiki.entryBodyPlaceholder":
    "Add background, uses, parameter definitions, or selection guidance",
  "wiki.publishReason": "Publication notes",
  "wiki.publishReasonPlaceholder":
    "For example: add a new part entry or data source",
  "wiki.datasheetOptional": "Datasheet (optional)",
  "wiki.choosePdf": "Select a PDF datasheet",
  "wiki.pdfHelp":
    "PDF only, up to 50 MB; an upload is not required to publish.",
  "wiki.publishMode": "Publication mode",
  "wiki.immediate": "Publish immediately",
  "wiki.scheduled": "Schedule publication",
  "wiki.scheduledAt": "Scheduled publication time",
  "wiki.chooseFutureTime": "Choose a future publication time",
  "wiki.scheduleHelp":
    "The entry is reviewed first and published at the scheduled time only after approval.",
  "wiki.manageSchedule": "Manage scheduled publications",
  "wiki.saveSchedule": "Save schedule",
  "wiki.submitReview": "Submit for review",
  "wiki.scheduleManager": "Scheduled publication management",
  "wiki.noScheduled": "No entries awaiting publication",
  "wiki.scheduledTime": "Scheduled time: ",
  "wiki.changeTime": "Change time",
  "wiki.publishNow": "Publish now",
  "wiki.cancelSchedule": "Cancel schedule",
  "wiki.reviewProcess": "Agent review process",
  "wiki.checked": "Check complete",
  "wiki.failed": "Failed",
  "wiki.complete": "Complete",
  "wiki.factCheck": "Fact-by-fact verification",
  "wiki.factClaim": "Factual claim",
  "wiki.datasheetPage": "Datasheet page {page}",
  "wiki.noPage": "No source page available",
  "wiki.reviseHint":
    "Please revise the entry according to {opinion} and resubmit it for review.",
  "wiki.reviseByOpinion": "Revise as requested",
  "wiki.withdrawHint":
    "You may withdraw this submission and keep it as a draft.",
  "wiki.withdraw": "Withdraw submission",
  "wiki.withdrawnHint":
    "This submission has been withdrawn from review. You may edit or delete the draft.",
  "wiki.continueEdit": "Continue editing",
  "wiki.deleteDraft": "Delete draft",
  "wiki.manualReviewOpinion":
    "Manual review notes (required when returning or rejecting)",
  "wiki.manualReviewPlaceholder":
    "Describe what the user must change and why; these notes will appear in the review feedback",
  "wiki.manualReviewRequired":
    "Notes are optional for approval but required when returning or rejecting an entry",
  "wiki.approvePublish": "Approve and publish",
  "wiki.returnForRevision": "Return for revision",
  "wiki.rejectReview": "Reject review",
  "wiki.reviewManagement": "Review and publication management",
  "wiki.reviewManagementHint":
    "Manage whether this entry may appear in the public encyclopedia",
  "wiki.currentStatus": "Current status",
  "wiki.completeness": "Information completeness",
  "wiki.readyToPublish": "Ready for publication checks",
  "wiki.completeBeforePublish":
    "Complete missing information before publishing",
  "wiki.publishCheck": "Publication checks",
  "wiki.present": "Complete",
  "wiki.missing": "Missing",
  "wiki.missingFields": "Missing fields:",
  "wiki.allProducts": "All products",
  "wiki.otherInitial": "Other",
  "wiki.batchReview": "Submit entries for batch review",
  "wiki.batchReviewHint":
    "Each entry is reviewed independently and appears publicly only after approval.",
  "wiki.uploadExtract": "Upload a file to extract encyclopedia entries",
  "wiki.batchImportHelp":
    "Supports xlsx, xls, csv, json, and txt. Columns may include entry name, definition, content, publication notes, brand, and category.",
  "wiki.parsedFile": "Parsed: ",
  "wiki.batchSize": "Entries per batch",
  "wiki.itemsUnit": "entries",
  "wiki.submitInterval": "Submit interval",
  "wiki.secondsUnit": "seconds",
  "wiki.batchDefaultHint":
    "By default, 10 entries are submitted every 5 seconds to the review API; they are not published directly.",
  "wiki.submittingEach": "Submitting entries for review",
  "wiki.batchCancelled": "Batch submission cancelled",
  "wiki.submitProgress": "Review submission progress",
  "wiki.batchNext":
    "The next batch will be submitted {seconds} seconds after this one completes.",
  "wiki.batchRemaining":
    "{count} entries have not been submitted. Edit them and restart.",
  "wiki.batchFailed":
    "{count} entries failed to submit and remain in the list. Please retry later.",
  "wiki.totalItems": "{count} entries in total",
  "wiki.addOne": "Add an entry",
  "wiki.entryNumber": "Encyclopedia entry {number}",
  "wiki.entryNameMissing": "Entry name not provided",
  "wiki.fillFromFile": "Fill this entry from a file",
  "wiki.delete": "Delete",
  "wiki.brand": "Brand",
  "wiki.category": "Category",
  "wiki.extractFromFile": "Extract from file",
  "wiki.addEntry": "Add an encyclopedia entry",
  "wiki.cancelSubmit": "Cancel submission",
  "wiki.submittingReview": "Submitting for review",
  "wiki.continueSubmit": "Continue submitting for review",
  "wiki.startBatchSubmit": "Start batch submission",
  "wiki.entryKicker": "Chip encyclopedia entry",
  "wiki.copyEntryName": "Copy entry name",
  "wiki.edit": "Edit",
  "wiki.favorited": "Favorited",
  "wiki.entryDefinitionPlaceholderShort": "Enter an entry definition",
  "wiki.introLoading": "Loading product introduction…",
  "wiki.noIntro": "No product introduction available",
  "wiki.contents": "Contents",
  "wiki.basicInfo": "Basic information",
  "wiki.datasheetResults": "Datasheet PDF and parsed results",
  "wiki.fullscreen": "View fullscreen",
  "wiki.downloadDatasheet": "Download datasheet",
  "wiki.datasheet": "Datasheet",
  "wiki.exitFullscreen": "Exit fullscreen",
  "wiki.noDatasheet": "No datasheet PDF linked to this product",
  "wiki.datasheetLabel": "Datasheet: ",
  "wiki.noFilename": "Filename unavailable",
  "wiki.parsingStatus": "Parse status: ",
  "wiki.datasheetCharts": "Datasheet charts",
  "wiki.specification": "Specifications",
  "wiki.technicalFeatures": "Technical features",
  "wiki.summaryLoading": "Searching the datasheet and generating a summary…",
  "wiki.applications": "Applications",
  "wiki.usageNotes": "Usage notes",
  "wiki.backToCommunity": "Back to Q&A home",
  "wiki.recommendedTopics": "Recommended topics",
  "wiki.topicIntroduction": "Topic introduction",
  "wiki.engineeringGuide": "Engineering guide",
  "wiki.backToOverview": "Back to overview",
  "wiki.featuredQnA": "Featured Q&A",
  "wiki.questionCount": "{count} questions",
  "wiki.topicContents": "Topic contents",
  "wiki.ordinal1": "1",
  "wiki.ordinal2": "2",
  "wiki.ordinal3": "3",
  "wiki.ordinal4": "4",
  "wiki.ordinal5": "5",
  "wiki.ordinal6": "6",
  "wiki.ordinal7": "7",
  "wiki.backToCommunityShort": "Back to Q&A",
  "wiki.userQnA": "User Q&A",
  "wiki.experienceSharing": "Technical discussion · Shared experience",
  "wiki.experienceIntro": "Where real experience meets reliable evidence.",
  "wiki.revalidateLogin": "Verify sign-in again",
  "wiki.currentLocation": "Current location",
  "wiki.allQuestionsShort": "All questions",
  "wiki.questionDetails": "Question details",
  "wiki.communityDiscussion": "Community discussion",
  "wiki.hasAcceptedAnswer": "Has an accepted answer",
  "wiki.allAnswers": "All answers",
  "wiki.experienceValued": "Every experience deserves to be heard",
  "wiki.noAnswersYet": "No answers yet. Share your experience.",
  "wiki.aiReference": "AI reference",
  "wiki.basedOnEncyclopedia": "Based on encyclopedia content",
  "wiki.sharedExperience": "Shared practical experience",
  "wiki.accepted": "Accepted",
  "wiki.unlike": "Remove like",
  "wiki.helpful": "Helpful",
  "wiki.unaccept": "Unaccept",
  "wiki.acceptAnswer": "Accept answer",
  "wiki.yourAnswer": "Your answer",
  "wiki.comments": "Comments",
  "wiki.loadingComments": "Loading comments…",
  "wiki.noComments": "No comments yet.",
  "wiki.writeComment": "Write a comment",
  "wiki.postComment": "Post comment",
  "wiki.shareInsight": "Share your insight",
  "wiki.replyHint":
    "Share practical experience and attach a datasheet or test evidence if available.",
  "wiki.writeAnswerWithEvidence": "Write your answer and supporting evidence",
  "wiki.addAttachment": "Add images or documents",
  "wiki.attachmentLimit": "Up to 8 files, 10 MB each",
  "wiki.uploading": "Uploading…",
  "wiki.remove": "Remove",
  "wiki.questionCountTogether": "{count} questions · Find answers together",
  "wiki.searchUserQuestions": "Search user questions",
  "wiki.search": "Search",
  "wiki.noQuestionsPostFirst": "No related questions. Post the first one.",
  "wiki.backToQnA": "Back to Q&A",
  "wiki.technicalQnADetails": "Technical Q&A details",
  "wiki.questionProductIntro":
    "Discuss {product} specifications, selection, and practical use. Share datasheet evidence or project experience.",
  "wiki.moreExperienceWelcome": " answers; add your experience",
  "wiki.letMeAnswer": "Answer this",
  "wiki.helpEngineers": "Share experience and help other engineers",
  "wiki.encyclopediaCommunity": "Encyclopedia · Community",
  "wiki.communityExperience": "Community experience",
  "wiki.sortByTime": "Sorted by time",
  "wiki.loadingAnswers": "Loading answers…",
  "wiki.aiReferenceAnswer": "AI reference answer",
  "wiki.encyclopediaContent": "Encyclopedia content",
  "wiki.experienceShared": "Shared experience",
  "wiki.viewAnswerEvidence": "View answer evidence",
  "wiki.viewProductEntry": "View product entry",
  "wiki.hideComments": "Hide comments",
  "wiki.deleting": "Deleting…",
  "wiki.deleteAnswer": "Delete answer",
  "wiki.continueDiscussion": "Continue discussing this answer",
  "wiki.noCommentsInvite":
    "No comments yet. Share your view or ask a follow-up.",
  "wiki.commentOnAnswer": "Comment on {author}'s answer",
  "wiki.commentPlaceholder": "What do you think of this answer?",
  "wiki.commentSavedNotice": "Your comment will be saved to the community",
  "wiki.answerDetailPlaceholder":
    "Share datasheet evidence, test results, or practical experience…",
  "wiki.deleteNamedImage": "Remove image {name}",
  "wiki.deleteNamedFile": "Remove file {name}",
  "wiki.attachmentSavedHelp":
    "PNG/JPG/GIF/WebP images and PDF/TXT/CSV/DOCX/XLSX/PPTX files; up to 8 files in total, 10 MB each. Attachments are saved with the answer.",
  "wiki.relatedSearches": "Related searches",
  "wiki.othersSearch": "Others also search",
  "wiki.generatingRelated": "Generating related searches…",
  "wiki.regenerate": "Generate again",
  "wiki.makeExperienceVisible": "Let more people see your experience",
  "wiki.yourExperienceAnswer": "Your experience may be someone else's answer.",
  "wiki.shareEvidence":
    "Share datasheet evidence, test results, or project experience.",
  "wiki.joinAnswering": "Join the discussion",
  "wiki.noPendingAnswers": "No unanswered questions at the moment",
  "wiki.communityMark": "Q",
  "wiki.chipQnA": "Chip Q&A",
  "wiki.technicalCommunity": "Technical Q&A community",
  "wiki.communitySearchPlaceholder":
    "Search models, packages, specifications, or technical questions",
  "wiki.searchAnswers": "Search answers",
  "wiki.xsouQnA": "XSOU Q&A",
  "wiki.reliableAnswers": "Reliable answers to technical questions",
  "wiki.communityIntro":
    "Discuss chip models, specifications, package compatibility, and practical experience.",
  "wiki.technicalQuestions": "Technical questions",
  "wiki.professionalAnswers": "Expert answers",
  "wiki.popularChipTypes": "Popular chip types",
  "wiki.semiconductorBasics": "Semiconductor basics",
  "wiki.hotDiscussions": "Popular discussions",
  "wiki.everyoneAsks": "Questions people ask",
  "wiki.viewAll": "View all",
  "wiki.searchProductForAi":
    "Search a specific product model for AI Q&A based on encyclopedia content",
  "wiki.chipImage": "{product} chip",
  "wiki.communityContribution": "Community contributions",
  "wiki.influenceRanking": "Contributor rankings",
  "wiki.loadingCommunityRecords": "Loading community records",
  "wiki.aiRolesDisclaimer":
    "No human Q&A yet. AI roles are shown below and do not represent real user rankings.",
  "wiki.weeklyRankingNote": "Based on posts and helpful votes this week",
  "wiki.weeklyActive": "Most active this week",
  "wiki.roleDisplay": "Role display",
  "wiki.weeklyPosts": "Weekly posts",
  "wiki.qualityContributors": "Helpful answer contributors",
  "wiki.contributionSummary":
    "{answers} answers · {comments} comments · {likes} helpful votes",
  "wiki.likesReceived": "Helpful votes",
  "wiki.awaitingProfessionalAnswer":
    "These questions are awaiting expert answers",
  "wiki.reload": "Reload",
  "wiki.searchingQnA": "Searching related Q&A…",
  "wiki.searchIncomplete": "Search is not complete",
  "wiki.searchResultCount": "{count} results found",
  "wiki.findingQnA": "Finding related Q&A",
  "wiki.matchingKnowledge":
    "Matching published product knowledge. Please wait…",
  "wiki.loadQuestionsFailed": "Could not load Q&A",
  "wiki.retrySearchHint": "Please try again later to reload search results.",
  "wiki.noRelatedQnA": "No related Q&A found",
  "wiki.noMatchFor": "No published Q&A matches “{keyword}”",
  "wiki.noPublishedQnA": "No published Q&A available yet",
  "wiki.tryFullModel":
    "Try a full product model, fewer keywords, or check the letters and numbers in the model.",
  "wiki.hotSearches": "Popular searches",
  "wiki.noRealSearches": "No search records yet",
  "wiki.communityRuleRelevant":
    "Ask about chip models, specifications, practical experience, or alternatives.",
  "wiki.communityRuleNoTrade":
    "Do not post transaction offers, contact details, or unrelated information.",
  "wiki.communityTitleExample":
    "For example: How can I verify package compatibility for IS62WV51216?",
  "wiki.communityDetailsPlaceholder":
    "Add a model, use case, confirmed specification, or observed behavior…",
  "wiki.postQuestionHint":
    "After posting, see answers on the question page and discuss with other users.",
  "wiki.fitPage": "Fit page",
  "wiki.rotate": "Rotate",
  "wiki.annotate": "Annotate",
  "wiki.undo": "Undo",
  "wiki.redo": "Redo",
  "wiki.download": "Download",
  "wiki.print": "Print",
  "wiki.more": "More",
  "wiki.datasheetThumbnailPage": "Datasheet thumbnail, page {page}",
  "wiki.productDatasheetPage": "{model} datasheet, page {page}",
  "wiki.packageInfo": "Package information",
  "wiki.packageImage": "Package image",
  "wiki.packageType": "Package type",
  "wiki.pinCount": "Pin count",
  "wiki.packageSize": "Package size",
  "wiki.operatingTemperature": "Operating temperature",
  "wiki.relatedTerms": "Related terms",
  "wiki.references": "References",
  "wiki.sameSeriesDatasheets": "Datasheets in the same series",
  "wiki.sameSeriesHint":
    "Matches product series and model families using the remote Xunzhi knowledge base",
  "wiki.modelCount": "{count} models",
  "wiki.loadingSameSeries": "Loading same-series datasheets",
  "wiki.sameSeriesFailed": "Could not load same-series datasheets",
  "wiki.indexedAt": "Indexed on ",
  "wiki.noSameSeries": "No same-series datasheets found",
  "wiki.noSameSeriesHint":
    "No clear same-series model is available in the remote knowledge base. Ask the AI assistant to find similar products.",
  "wiki.askAi": "Ask AI assistant",
  "wiki.relatedKnowledgeProducts": "Related knowledge-base products",
  "wiki.relatedProductsHint":
    "Recommendations by manufacturer, category, and model similarity; no stock or demo price data",
  "wiki.loadingRelatedProducts": "Loading related products",
  "wiki.relatedProductsFailed": "Could not load related products",
  "wiki.noRelatedKnowledgeProducts": "No related knowledge-base products found",
  "wiki.noRelatedKnowledgeHint":
    "Ask the AI assistant to recommend products based on this model's specifications and use.",
  "wiki.aiRecommend": "Ask AI to recommend",
  "wiki.siteLinks": "Related XSOU links",
  "wiki.siteLinksHint": "Continue exploring related materials for this entry",
  "wiki.imageMaterials": "Images",
  "wiki.uploadImage": "Upload images",
  "wiki.deleteCurrent": "Delete current",
  "wiki.previousImage": "Previous image",
  "wiki.nextImage": "Next image",
  "wiki.noImagesUpload": "No images yet. Upload one to add it.",
  "wiki.noImages": "No images available",
  "wiki.videoMaterials": "Videos",
  "wiki.uploadVideo": "Upload videos",
  "wiki.deleteVideo": "Delete video",
  "wiki.videoNumber": "Video {number}",
  "wiki.noVideosUpload": "No videos yet. Upload one to add it.",
  "wiki.videosViaEdit": "Edit this entry to add videos",
  "wiki.entryStats": "Entry information",
  "wiki.viewsCount": "Views: {count}",
  "wiki.editsCount": "Edits: {count}",
  "wiki.history": "Version history",
  "wiki.latestAt": "Last updated: ",
  "wiki.latestEditor": "Last editor: ",
  "wiki.topContributors": "Top contributors",
  "wiki.contributorEdits": "{count} edits",
  "wiki.relatedInfo": "Related information",
  "wiki.relatedTags": "Related tags",
  "wiki.detail.alreadyPublished":
    "This entry is already published. To add information, select Edit in the entry content instead of reviewing it again.",
  "wiki.detail.aiCorrections": "AI correction suggestions",
  "wiki.detail.aiCorrectionsHint":
    "Each suggestion must have supporting evidence. Confirmation creates a revised version for review; it does not publish it directly.",
  "wiki.detail.awaitingConfirmation": "Awaiting your confirmation",
  "wiki.detail.before": "Before",
  "wiki.detail.suggested": "Suggested change",
  "wiki.detail.reason": "Reason: {reason}",
  "wiki.detail.evidence": "Evidence: {evidence}",
  "wiki.detail.evidenceBased": "Revised based on review evidence",
  "wiki.detail.viewCorrected": "View the complete AI-revised content",
  "wiki.detail.acceptCorrections": "Accept and resubmit for review",
  "wiki.detail.manualReview": "Decline and request human review",
  "wiki.detail.saveAndReview": "Save and submit for review",
  "wiki.detail.saveDraft": "Save draft",
  "wiki.detail.save": "Save",
  "wiki.detail.resubmitReview": "Save and resubmit for review",
  "wiki.detail.saveAndPublish": "Save and publish",
  "wiki.detail.loginToEdit": "Sign in before editing this encyclopedia entry",
  "wiki.detail.draftUnavailable":
    "No editable draft is available yet. Try again shortly",
  "wiki.detail.draftLoadFailed":
    "Could not load the encyclopedia draft. Try again later",
  "wiki.detail.loginToPublish":
    "Sign in before editing or publishing this entry",
  "wiki.detail.requiredFields":
    "Enter the entry name, definition and article content",
  "wiki.detail.revisionSubmitted":
    "Changes submitted for review. The edit count updates after approval and publication",
  "wiki.detail.submitFailed": "Could not submit the changes",
  "wiki.detail.largeFile":
    "Could not save. An uploaded file may be too large; remove or compress it and try again",
  "wiki.detail.saveFailed": "Could not save the changes",
  "wiki.detail.revisionSaved":
    "Changes submitted and recorded as a new entry version",
  "wiki.detail.draftNotFound": "No encyclopedia draft is available to save",
  "wiki.detail.draftSaveFailed": "Could not save the encyclopedia draft",
  "wiki.detail.correctionsConfirmed":
    "AI corrections confirmed. The revision was resubmitted for review",
  "wiki.detail.correctionsFailed": "Could not confirm the AI corrections",
  "wiki.detail.sentToHuman":
    "Sent for human review. Check My publications for progress",
  "wiki.detail.humanReviewFailed": "Could not request human review",
  "wiki.detail.loginToRelease":
    "Sign in before publishing an encyclopedia entry",
  "wiki.detail.releaseFailed": "Could not publish the encyclopedia content",
  "wiki.detail.draftSaved": "Encyclopedia draft saved to the database",
  "wiki.detail.needsRevision":
    "Review requires changes. Update the content and submit again",
  "wiki.detail.highRisk":
    "High-risk or uncertain content was sent for human review",
  "wiki.detail.reviewSubmitted": "Encyclopedia content submitted for AI review",
  "wiki.detail.scheduled": "AI review passed; scheduled publication is pending",
  "wiki.detail.rewarded":
    "Encyclopedia content approved and published: +{points} points",
  "wiki.detail.rewardLimit":
    "Encyclopedia content approved and published; today's reward limit of {limit} points has been reached",
  "wiki.detail.published": "Encyclopedia content published",
  "wiki.detail.reviewStatus":
    "Content submitted for review. Check My for the result",
  "wiki.detail.reviewRewarded":
    "Encyclopedia content approved: +{points} points. Select to view details",
  "wiki.detail.reviewRewardLimit":
    "Encyclopedia content approved; today's reward limit of {limit} points has been reached",
  "wiki.detail.assistantTitle": "Encyclopedia AI assistant",
  "wiki.detail.assistantSubtitle":
    "Searches encyclopedia entries and datasheets",
  "wiki.detail.collapseAssistant": "Collapse",
  "wiki.detail.viewConversation": "View conversation",
  "wiki.detail.me": "Me",
  "wiki.detail.sourceCatalog":
    "Based on actual part numbers in the product catalog",
  "wiki.detail.sourceClarify": "More details are needed to answer",
  "wiki.detail.sourceModel":
    "Based on general model knowledge, not a datasheet citation",
  "wiki.detail.sourceAll": "Searched datasheets across the knowledge base",
  "wiki.detail.sourceCurrent": "Searched this entry's datasheet",
  "wiki.detail.datasheet": "Datasheet",
  "wiki.detail.page": "Page {page}",
  "wiki.detail.parameterRecord": "Parameter record",
  "wiki.detail.tryAsking": "Try asking",
  "wiki.detail.voltageQuestion": "What is this product's operating voltage?",
  "wiki.detail.packageQuestion": "What package does this product use?",
  "wiki.detail.compareQuestion":
    "Compare this product's operating voltage and package with similar models.",
  "wiki.detail.searchQuestion":
    "Which products in the knowledge base support 3 V power?",
  "wiki.detail.voltage": "Operating voltage",
  "wiki.detail.package": "Package",
  "wiki.detail.compare": "Compare models",
  "wiki.detail.searchAll": "Search all",
  "wiki.detail.assistantLongWait":
    "This is taking longer than usual. Please wait, or pause at any time.",
  "wiki.detail.assistantWorking":
    "Using the conversation and searching sources as needed.",
  "wiki.detail.seconds": "{count} s",
  "wiki.detail.questionPlaceholder":
    "Ask about an entry, part number, brand or comparison…",
  "wiki.detail.pauseAnswer": "Pause this answer",
  "wiki.detail.pause": "Pause",
  "wiki.detail.send": "Send",
  "wiki.detail.sourceHint":
    "Search scope is selected automatically; answers include source evidence",
  "wiki.detail.shortcut": "Ctrl + Enter to send",
  "wiki.detail.schedulePrompt":
    "Enter a publication time (for example, 2026-08-03 18:30:00)",
  "wiki.detail.scheduleTitle": "Schedule encyclopedia publication",
  "wiki.detail.scheduleFormat": "Enter YYYY-MM-DD HH:mm or YYYY-MM-DD HH:mm:ss",
  "wiki.detail.scheduleFuture": "Publication time must be in the future",
  "wiki.detail.scheduleSaved":
    "Schedule saved. The article will publish at the selected time",
  "wiki.detail.scheduleFailed":
    "Could not schedule the encyclopedia publication",
});

export const messages = Object.freeze({ ...personal, ...display, ...pages });
